import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import whatsappicon from "../../Images/whatsappicon.png";
import gmailicon from "../../Images/gmailicon.png";
import mobicon from "../../Images/mobicon.png";
import signuppopupheadimg from "../../Images/signuppopupheadimg.png";
import { FaCheckCircle } from "react-icons/fa";
import { toast } from "react-toastify";
import { fetchOTPs } from "./modalSlices/MobileEmailModalSlice";

// Component to handle OTP input
const OtpInput = ({ onOtpChange, onResendOTP, otpResent, timer }) => {
  const inputs = useRef([]);
  const [allFieldsFilled, setAllFieldsFilled] = useState(false);

  useEffect(() => {
    inputs.current[0]?.focus();
  }, []);

  const handleChange = (index, e) => {
    const digit = e.target.value.slice(-1);
    if (/^\d$/.test(digit)) {
      inputs.current[index].value = digit;
      if (index < inputs.current.length - 1) {
        inputs.current[index + 1]?.focus();
      }
    } else if (digit === "") {
      inputs.current[index].value = "";
    }

    const isOtpFilled = inputs.current.every((input) => input?.value !== "");
    setAllFieldsFilled(isOtpFilled);
    onOtpChange(inputs.current.map((input) => input?.value).join(""));
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (inputs.current[index]?.value === "" && index > 0) {
        inputs.current[index - 1]?.focus();
      }
    }
  };

  return (
    <div className="container flex flex-col items-center">
      <div className="flex mb-3">
        {[...Array(4)].map((_, index) => (
          <div key={index} className="mx-1">
            <input
              type="text"
              maxLength={1}
              className="form-control text-center border border-gray-300 rounded w-10 h-10"
              ref={(el) => (inputs.current[index] = el)}
              onChange={(e) => handleChange(index, e)}
              onKeyDown={(e) => handleKeyDown(index, e)}
            />
          </div>
        ))}
      </div>
      {/* {!otpResent && ( */}
      <button onClick={onResendOTP} className="text-blue-500 text-sm">
        Resend OTP
      </button>
      {/* )} */}
      {otpResent && (
        <p className="text-gray-600">
          {timer < 10 ? `00:0${timer}` : `00:${timer}`}
        </p>
      )}
    </div>
  );
};

// Component for a single verification section
const VerificationSection = ({
  icon,
  label,
  otpKey,
  otp,
  onOtpChange,
  onVerify,
  onResendOTP,
  verified,
}) => (
  <div className="p-6 text-center border-r last:border-none">
    <img src={icon} alt={`${label} Icon`} className="mx-auto h-20 w-20 mb-2" />
    <p className="text-sm text-gray-600 mb-2">
      <strong>{`Verify your ${label}`}</strong>
    </p>
    {!verified ? (
      <>
        <OtpInput onOtpChange={onOtpChange} onResendOTP={onResendOTP} />
        <button
          type="button"
          className="px-4 py-2 mt-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
          onClick={onVerify}
        >
          Verify
        </button>
      </>
    ) : (
      <div className="mt-4">
        <FaCheckCircle className="text-green-600 text-3xl mx-auto" />
        <p className="text-sm text-green-600 mt-2">Verified</p>
      </div>
    )}
  </div>
);

// Main modal component
const MobileEmailModal = ({
  onClose1,
  onVerificationStatusChange,
  mobileVerified,
  emailVerified,
  whatsappVerified,
  onVerificationComplete,
  onSubmitModal,
  requireWhatsapp,
  mobileNo,
  emailAddr,
  whatsappNo,
  firstName,
}) => {
  const [otp, setOtp] = useState({
    mobile: "",
    email: "",
    whatsapp: "",
  });
  const dispatch = useDispatch();
  const { mobileOtp, emailOtp, whatsappOtp } = useSelector(
    (state) => state.MobileEmailOtp
  );

  useEffect(() => {
    console.log("Redux OTP State Updated:", {
      mobileOtp,
      emailOtp,
      whatsappOtp,
    });
  }, [mobileOtp, emailOtp, whatsappOtp]);

  const handleVerify = (key) => {
    const enteredOtp = otp[key];
    const storedOtp = {
      mobile: mobileOtp,
      email: emailOtp,
      whatsapp: whatsappOtp,
    }[key];

    if (enteredOtp === storedOtp) {
      const updatedStatus = {
        mobile: key === "mobile" ? true : mobileVerified,
        email: key === "email" ? true : emailVerified,
        whatsapp: key === "whatsapp" ? true : whatsappVerified,
      };
      onVerificationStatusChange(
        updatedStatus.mobile,
        updatedStatus.email,
        updatedStatus.whatsapp
      );
    } else {
      toast.error("Incorrect OTP. Please try again.");
    }
  };

  const handleSubmit = () => {
    // if (!(mobileVerified && emailVerified && whatsappVerified)) {
    //   toast.warning("Please Verify every Field");
    //   return;
    // }
    const needWhatsapp = !!requireWhatsapp;
    const ok =
      mobileVerified && emailVerified && (!needWhatsapp || whatsappVerified);
    if (!ok) {
      toast.warning(
        needWhatsapp
          ? "Please verify Mobile, Email and WhatsApp."
          : "Please verify Mobile and Email."
      );
      return;
    }
    onVerificationComplete();
    onSubmitModal();
  };

  useEffect(() => {
    if (
      mobileVerified &&
      emailVerified &&
      (!requireWhatsapp || whatsappVerified)
    ) {
      onVerificationComplete();
    }
  }, [
    mobileVerified,
    emailVerified,
    whatsappVerified,
    requireWhatsapp,
    onVerificationComplete,
  ]);

  const handleResendOTP = async (type) => {
    try {
      const payload = {};

      // Set the correct field based on the type
      // if (type === "mobile") {
      //   payload.mobile = otp.mobile;
      // } else if (type === "email") {
      //   payload.email = otp.email;
      // } else if (type === "whatsapp") {
      //   payload.whatsappNo = otp.whatsapp;
      //   // payload.firstName = "User"; // Replace with the actual first name if available
      // }

      if (type === "mobile" && mobileNo) payload.mobile = mobileNo;
      if (type === "email" && emailAddr) payload.email = emailAddr;
      if (type === "whatsapp" && whatsappNo) {
        payload.whatsappNo = whatsappNo;
        payload.firstName = firstName || "User";
      }

      // Ensure at least one field is present
      if (!payload.mobile && !payload.email && !payload.whatsappNo) {
        toast.error("Please provide a valid number or email.");
        return;
      }
      // Dispatch OTP request
      await dispatch(fetchOTPs(payload)).unwrap();

      // Show success toast
      toast.success(
        `${type.charAt(0).toUpperCase() + type.slice(1)} OTP sent successfully!`
      );
    } catch (error) {
      // Check for specific error messages
      const message = error.message || error;
      if (message.includes("Too many requests") || message.includes("429")) {
        toast.error(
          "OTP already sent. Please wait 30 seconds before requesting again."
        );
      } else {
        toast.error("Failed to send OTP. Please try again.");
      }
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-full max-w-4xl rounded-lg shadow-lg">
        <div
          className="h-28 rounded-t-lg bg-cover"
          style={{
            backgroundImage: `url(${signuppopupheadimg})`,
          }}
        ></div>
        <div className="px-8 pb-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <VerificationSection
              icon={mobicon}
              label="mobile no."
              otpKey="mobile"
              otp={otp.mobile}
              onOtpChange={(value) =>
                setOtp((prev) => ({ ...prev, mobile: value }))
              }
              onVerify={() => handleVerify("mobile")}
              // onResendOTP={() => console.log("Resend Mobile OTP")}
              onResendOTP={() => handleResendOTP("mobile")}
              verified={mobileVerified}
            />
            <VerificationSection
              icon={gmailicon}
              label="Email ID"
              otpKey="email"
              otp={otp.email}
              onOtpChange={(value) =>
                setOtp((prev) => ({ ...prev, email: value }))
              }
              onVerify={() => handleVerify("email")}
              // onResendOTP={() => console.log("Resend Email OTP")}
              onResendOTP={() => handleResendOTP("email")}
              verified={emailVerified}
            />
            {/* <VerificationSection
              icon={whatsappicon}
              label="WhatsApp no."
              otpKey="whatsapp"
              otp={otp.whatsapp}
              onOtpChange={(value) =>
                setOtp((prev) => ({ ...prev, whatsapp: value }))
              }
              onVerify={() => handleVerify("whatsapp")}
              // onResendOTP={() => console.log("Resend WhatsApp OTP")}
              onResendOTP={() => handleResendOTP("whatsapp")}
              verified={whatsappVerified}
            /> */}
            {requireWhatsapp && whatsappNo ? (
              <VerificationSection
                icon={whatsappicon}
                label="WhatsApp no."
                otpKey="whatsapp"
                otp={otp.whatsapp}
                onOtpChange={(value) =>
                  setOtp((prev) => ({ ...prev, whatsapp: value }))
                }
                onVerify={() => handleVerify("whatsapp")}
                onResendOTP={() => handleResendOTP("whatsapp")}
                verified={whatsappVerified}
              />
            ) : null}
          </div>
          <div className="flex justify-center space-x-6 mt-6">
            <button
              type="button"
              className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
              onClick={onClose1}
            >
              Cancel
            </button>
            <button
              type="submit"
              onClick={handleSubmit}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileEmailModal;
